import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { orgAccountEdit } from '../../../api/orgTripAPI';

export const editOrgAccount = (data, setLoading, setModal, setRender) => {
    if (data.about.length > 200) {
        toast.error('About must be less than 200 characters');
    } else if (data.about.length < 20) {
        toast.error('About must be more than 200 characters');
    } else {
        try {
            orgAccountEdit(data).then((res) => {
                if (res.status === 200) {
                    setLoading(false);
                    toast.success('Account updated successfully');
                    setModal(false);
                    setRender(true);
                } else {
                    setLoading(false);
                    toast.error('Something went wrong');
                }
            });
        } catch (err) {
            setLoading(false);
            errorHandle();
        }
    }
};
